module.exports = __webpack_public_path__ + "static/media/comedy.17ee73c5.jpg";